import {environment} from "../../environments/environment";
import {HttpMethod} from "@auth0/auth0-angular";

export const authConfig = {
  domain: environment.auth0.domain,
  clientId: environment.auth0.clientId,
  authorizationParams: {
    redirect_uri: environment.auth0.authorizationParams.redirect_uri,
    audience: environment.auth0.authorizationParams.audience,
    scope: 'email authenticate validate:imei read:order write:order write:customer ' +
      'activate:device read:team update:device read:documentation read:bulk write:bulk ' +
      'write:gateway-environment read:gateway-environment write:gateway-order read:gateway-order'
  },
  httpInterceptor: {
    allowedList: [
      {
        uri: environment.apiUrlPrefix + 'device/validate/*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'validate:imei'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'device/validate',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'validate:imei'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'orders',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'order/*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'order/*',
        httpMethod: HttpMethod.Delete,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'order',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'bulkUpload',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'order',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'internalOrder',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'device/activate',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'activate:device'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'device/deactivate',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'update:device'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'customer/*',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:customer'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'hub/team/*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:team'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'devices',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'update:device'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'devices',
        httpMethod: HttpMethod.Delete,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'update:device'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'report/imei',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'report/blx',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'report/recreate/csv',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlPrefix + 'report/deactivation/*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:order'
          },
        }
      },
      {
        uri: environment.apiUrlBulkPrefix + 'devices',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:bulk'
          }
        }
      },
      {
        uri: environment.apiUrlBulkPrefix.substring(0, environment.apiUrlBulkPrefix.length - 1),
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:bulk'
          }
        }
      },
      {
        uri: environment.apiUrlBulkPrefix + "*",
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:bulk'
          }
        }
      },
      {
        uri: environment.apiUrlBulkPrefix + 'imei/*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:bulk'
          }
        }
      },
      {
        uri: environment.apiUrlGatewayEnvPrefix + '*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:gateway-environment'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayEnvPrefix + '*',
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-environment'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayEnvPrefix + '*',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-environment'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayOrderPrefix.substring(0, environment.apiUrlGatewayOrderPrefix.length - 1),
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-order'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayOrderPrefix.substring(0, environment.apiUrlGatewayOrderPrefix.length - 1),
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:gateway-order'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayOrderPrefix + '*',
        httpMethod: HttpMethod.Get,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'read:gateway-order'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayOrderPrefix + '*',
        httpMethod: HttpMethod.Patch,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-order'
          },
        }
      },
      {
        uriMatcher: (uri: string) =>
          uri.startsWith(environment.apiUrlGatewayOrderPrefix) && uri.endsWith('/devices/import'),
        httpMethod: HttpMethod.Post,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-order'
          },
        }
      },
      {
        uri: environment.apiUrlGatewayOrderPrefix + '*',
        httpMethod: HttpMethod.Delete,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
            scope: 'write:gateway-order'
          },
        }
      }
    ],
  },
}
